import React from "react";
import { NavLink, useParams } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Wallet,
  CalendarCheck2,
} from "lucide-react";

import "./groupindividual.css";

export default function GroupNav() {
  const { groupid } = useParams();

  const tabs = [
    {
      id: "overview",
      title: "Overview",
      sub: "Summary",
      icon: <LayoutDashboard size={22} />,
    },
    {
      id: "members",
      title: "Members",
      sub: "Students",
      icon: <Users size={22} />,
    },
    {
      id: "transactions",
      title: "Payments",
      sub: "Fees",
      icon: <Wallet size={22} />,
    },
    {
      id: "attendance",
      title: "Attendance",
      sub: "Daily",
      icon: <CalendarCheck2 size={22} />,
    },
  ];

  return (
    <nav className="indigroup_tabs"  >
      {tabs.map((tab) => (
        <NavLink
          key={tab.id}
          to={`/dashboard/group-details/${groupid}/${tab.id}`}
          className={({ isActive }) =>
            `indigroup_tabBtn ${isActive ? "active" : ""}`
          }
        >
          <span className="tabIcon">{tab.icon}</span>

          <div className="tabContent">
            <span className="tabTitle">{tab.title}</span>
            <small>{tab.sub}</small>
          </div>
        </NavLink>
      ))}
    </nav>
  );
}